// src/components/common/SessionValidator/SessionValidator.js
// Component to handle automatic session validation when user returns

import { useEffect } from 'react';
import useSessionValidator from '../../../hooks/useSessionValidator';
import { useUser } from '../../../context/UserContext';
import { toast } from 'react-toastify';

const SessionValidator = ({ awayTimeMinutes = 10, enableNotifications = false, children }) => {
    const { currentUser } = useUser();
    const { setAwayTimeThreshold, validateSession } = useSessionValidator();

    // Set the threshold for considering user "away"
    useEffect(() => {
        setAwayTimeThreshold(awayTimeMinutes);
    }, [awayTimeMinutes, setAwayTimeThreshold]);


    // This component doesn't render anything visible
    // It just runs the session validation logic
    return children;
};

export default SessionValidator;